document.addEventListener('DOMContentLoaded', () => {
  const scrollContainer = document.getElementById('scrollContainer');
  const scrollLeftBtn = document.getElementById('scrollLeftBtn');
  const scrollRightBtn = document.getElementById('scrollRightBtn');

  function updateArrows() {
    const scrollLeft = scrollContainer.scrollLeft;
    const scrollWidth = scrollContainer.scrollWidth;
    const clientWidth = scrollContainer.clientWidth;

    scrollLeftBtn.style.display = scrollLeft > 0 ? 'block' : 'none';
    scrollRightBtn.style.display = scrollLeft + clientWidth < scrollWidth ? 'block' : 'none';
  }

  scrollContainer.addEventListener('scroll', updateArrows);
  window.addEventListener('resize', updateArrows);

  scrollLeftBtn.addEventListener('click', () => {
    scrollContainer.scrollBy({ left: -200, behavior: 'smooth' });
  });

  scrollRightBtn.addEventListener('click', () => {
    scrollContainer.scrollBy({ left: 200, behavior: 'smooth' });
  });

  window.addEventListener('load', updateArrows);
});
